import {DOCUMENT, Inject, Injectable, NgZone} from '@angular/core';
import {Observable} from 'rxjs';

import {mergeMap, shareReplay, take} from 'rxjs/operators';

@Injectable()
/**
 * Service to use Googles youtube iframe api
 * https://developers.google.com/youtube/iframe_api_reference
 */
export class YoutubeIFrameApiService {

    private isReady = new Observable<Event>(observer => {
        const script = this.document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://www.youtube.com/iframe_api';
        script.id = 'youtube_iframe_api';
        // @ts-expect-error onYouTubeIframeAPIReady is a YouTube IFrame API global
		this.document.defaultView['onYouTubeIframeAPIReady'] = (e: Event) => observer.next(e);
        this.document.body.appendChild(script);
    }).pipe(
        // shareReplay will make sure that the script is only loaded once, even when adding multiple video's on a page.
        shareReplay(1)
    );

    constructor(
        @Inject(DOCUMENT) private readonly document: Document,
        // https://github.com/angular/angular/issues/19814
        private readonly zone: NgZone
    ) {
    }

    public startVideo(videoId: string, iframeId: string): Observable<any> {
        return this.isReady.pipe(
            take(1),
            mergeMap(() => new Observable(o => {
                // @ts-expect-error YT is a YouTube IFrame API global
				new window['YT'].Player(iframeId, {
                    videoId,
                    playerVars: {
                        playsinline: 1,
                        modestbranding: 1,
                    },
                    events: {
                        onReady: (event: any) => {
                            /*
                             * a private video should trigger 'onError' event but in reality it's not happening.
                             * To solve this the duration of the video is checked.
                             */
                            this.zone.run(() => {
                                if (event.target.getDuration() > 0) {
                                    o.next(true);
                                    o.complete();
                                } else {
                                    o.error('Something is wrong with the video: ' + videoId);
                                    o.complete();
                                }
                            })
                        },
                        onError: (err: any) => {
                            this.zone.run(() => {
                                o.error(err);
                                o.complete();
                            });
                        }
                    }
                });
            }))
        );
    }
}
